export enum AbilityAction {
    MANAGE = 'manage',
    CREATE = 'create',
    READ = 'read',
    UPDATE = 'update',
    DESTROY = 'destroy',
}
